export default __webpack_public_path__ + "static/media/button_on.48012fe3.mp3";